// extracted by mini-css-extract-plugin
export var carrierTab = "_49-0";
export var carrierTabActive = "_49-1 _49-0";
export var carrierTabInactive = "_49-2 _49-0";
export var carrierTabLabel = "_49-3";
export var carrierTabLabelActive = "_49-4 _49-3";
export var carrierTabLabelInactive = "_49-5 _49-3";
export var carrierTabPercentage = "_49-6";
export var carrierTabPercentageActive = "_49-7 _49-6";
export var carrierTabPercentageInactive = "_49-8 _49-6";
export var carrierTabWinnable = "_49-9";
export var carrierTabWinnableActive = "_49-a _49-9";
export var carrierTabWinnableInactive = "_49-b _49-9";
export var comparisonContainer = "_49-d";
export var missingRateButton = "_49-n";
export var missingRateButtonActive = "_49-o _49-n";
export var missingRateButtonInactive = "_49-p _49-n";
export var missingRateButtonLabel = "_49-q";
export var missingRateButtonLabelActive = "_49-r _49-q";
export var missingRateButtonLabelInactive = "_49-s _49-q";
export var sidebar = "_49-c";
export var strategyButton = "_49-e";
export var strategyButtonActive = "_49-f _49-e";
export var strategyButtonDescription = "_49-k";
export var strategyButtonDescriptionActive = "_49-l _49-k";
export var strategyButtonDescriptionInactive = "_49-m _49-k";
export var strategyButtonInactive = "_49-g _49-e";
export var strategyButtonLabel = "_49-h";
export var strategyButtonLabelActive = "_49-i _49-h";
export var strategyButtonLabelInactive = "_49-j _49-h";
export var unitToggleButton = "_49-t";
export var unitToggleButtonActive = "_49-u _49-t";
export var unitToggleButtonInactive = "_49-v _49-t";
export var unitToggleButtonLabel = "_49-w";
export var unitToggleButtonLabelActive = "_49-x _49-w";
export var unitToggleButtonLabelInactive = "_49-y _49-w";